import { Route, Switch } from "wouter";
import { Layout } from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import SurpriseEngine from "./pages/SurpriseEngine";
import CountryDetail from "./pages/CountryDetail";
import Geopolitics from "./pages/Geopolitics";
import Regime from "./pages/Regime";
import CentralBanks from "./pages/CentralBanks";
import Communication from "./pages/Communication";
import { Brief } from "./pages/Brief";
import Methodology from "./pages/Methodology";

export default function App() {
  return (
    <Layout>
      <Switch>
        <Route path="/" component={Dashboard} />
        <Route path="/surprise" component={SurpriseEngine} />
        <Route path="/surprise/:country" component={CountryDetail} />
        <Route path="/geopolitics" component={Geopolitics} />
        <Route path="/geopolitics/:id" component={Geopolitics} />
        <Route path="/regime" component={Regime} />
        <Route path="/central-banks" component={CentralBanks} />
        <Route path="/communication" component={Communication} />
        <Route path="/brief" component={Brief} />
        <Route path="/methodology" component={Methodology} />
        <Route>
          <div className="mx-auto max-w-7xl text-sm text-slate-500">Page not found.</div>
        </Route>
      </Switch>
    </Layout>
  );
}
